import {useLoadSpacing} from '@hconnect/tuc-processes/fields/loadSpacing/useLoadSpacing'
import {Typography, Box} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useEnhancedLoadSpacingAdjustment} from '../../../../../orderIntake/hooks/useEnhancedLoadSpacingAdjustment'
import {useEnhancedLoadSpacingScenario} from '../../../../../orderIntake/hooks/useEnhancedLoadSpacingScenario'

import {SpacingOrFlowRateSelector} from './SpacingOrFlowRateSelector'
import {TimeOnJobSiteSelector} from './TimeOnJobSiteSelector'

export const IntervalsStep: React.FC = () => {
  const {t} = useTranslation()
  const scenario = useEnhancedLoadSpacingScenario()
  const {loadSpacingConfiguration} = useLoadSpacing()

  // Auto-adjust values when scenario changes
  useEnhancedLoadSpacingAdjustment()

  return (
    <Box>
      <Box sx={{width: '100%', my: 2, maxHeight: '400px', overflowY: 'scroll'}}>
        {(scenario.loadSpace || scenario.flowRate) && (
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: '#29333D'
              }}
            >
              {t('orderIntake.rmc.steps.intervals.spacingQuestion')}
            </Typography>
            <SpacingOrFlowRateSelector
              scenario={scenario}
              loadSpacingConfiguration={{loadSpacing: loadSpacingConfiguration}}
            />
          </Box>
        )}
        {scenario.timeOnJobSite && (
          <Box sx={{mt: 4}}>
            <Typography
              variant="subtitle1"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: '#29333D'
              }}
            >
              {t('orderIntake.rmc.steps.intervals.timeOnJobSiteQuestion')}
            </Typography>
            <TimeOnJobSiteSelector
              loadSpacingConfiguration={{loadSpacing: loadSpacingConfiguration}}
            />
          </Box>
        )}

        {/* Show message if no options are available */}
        {!scenario.loadSpace && !scenario.flowRate && !scenario.timeOnJobSite && (
          <Box sx={{p: 3, textAlign: 'center'}}>
            <Typography color="text.secondary">
              {t(
                'orderIntake.rmc.orderManagement.noIntervalConfigNeeded',
                'No interval configuration needed for this order.'
              )}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}
